<template>
  <client-only>
    <template #fallback>
      <app-button disabled size="lg" tag="span" />
    </template>

    <course-page-enrolment-registration-request-cta
      v-if="session.public && hasOrganizationMembership"
      block
      :course="course"
      :session="session"
      size="lg"
    />

    <course-page-enrolment-registration-link-cta
      v-else-if="!session.public && !currentUserIsAlreadyRegistered"
      block
      :course="course"
      :session="session"
      size="lg"
    />

    <app-button
      v-else-if="currentUserIsAlreadyRegistered"
      block
      data-cy-enroled-cta
      disabled
      size="lg"
    >
      <span>💜</span>
      <span class="text-black">{{ $t("course.page.enroled_label") }}</span>
    </app-button>

    <template v-else>
      <course-page-program-download-cta
        block
        :course="course"
        :session="session"
      />

      <course-page-enrolment-buy-cta
        block
        :session="session"
        size="lg"
        variant="tonal"
      />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageEnrolmentBuyCta from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-buy-cta.vue";
import CoursePageEnrolmentRegistrationLinkCta from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-registration-link-cta.vue";
import CoursePageEnrolmentRegistrationRequestCta from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-registration-request-cta.vue";
import CoursePageProgramDownloadCta from "~/pages/courses/[slug]/_includes/components/program/course-page-program-download-cta.vue";

const properties = defineProps<{
  course: CoursePageView;
  session: CourseSessionView;
}>();

const { isRegisteredToCourseSession } = useLearnerProfile();

const currentUserIsAlreadyRegistered = computed(() =>
  isRegisteredToCourseSession(properties.session.id),
);

const { hasOrganizationMembership } = useOrganizationMemberProfile();
</script>
